import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import GlobalTalentBG from "../../assets/images/Home/GlobalTalentBG.png";

const GlobalTalentSection = ({ scrollToRegisterEntity }: { scrollToRegisterEntity: () => void }) => {
  const { t } = useTranslation();

  return (
    <Box component="section" sx={{ padding: "13px 0" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          margin: "0 auto",
          width: "95%",
          maxWidth: "1240px",
          alignItems: "center",
          textAlign: "center",
          padding: {
            xs: "90px 0",
            lg: "146px 0",
          },
          backgroundImage: `url(${GlobalTalentBG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Typography
          component="h2"
          sx={{
            textAlign: "center",
            fontFamily: "Montserrat",
            fontStyle: "normal",
            fontWeight: 750,
            lineHeight: "normal",
            letterSpacing: "-0.8px",
            fontSize: {
              xs: "30px",
              lg: "40px",
            },
            textTransform: "uppercase",
            background: "linear-gradient(180deg, #FFF 0%, #B8C2CE 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            maxWidth: "1080px",
          }}
        >
          {t("pages.home.reachEngageHire")}
        </Typography>
        <Typography
          component="p"
          sx={{
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "28px",
            background: "linear-gradient(180deg, #FFF 0%, #B8C2CE 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            maxWidth: "900px",
          }}
        >
          {t("pages.home.revolutionizeManagement")}
        </Typography>
        <Button
          variant="primary-lg"
          sx={{
            width: {
              xs: "100%",
              lg: "fit-content",
            },
            background: "var(--Green---100, #008B07)",
            color: "var(--Base-White, #FFF)",
            fontFamily: "HeadingNowVarTrial",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "24px",
          }}
          onClick={scrollToRegisterEntity}
        >
          {t("pages.home.requestDemo")}
        </Button>
      </Box>
    </Box>
  );
};

export default GlobalTalentSection;
